import { Wrapper } from 'components/wrapper';

import { FooterProps } from './types';

export const Footer = ({
  title,
  logoSrc = '/images/logo.svg',
}: FooterProps) => {
  const year = new Date().getFullYear();

  return (
    <footer className="pt-10">
      <Wrapper className="py-4">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-3">
            <div className="shrink-0">
              <img width="48" height="48" alt={title} src={logoSrc} />
            </div>
            <p className="max-w-75.5 font-semibold uppercase">{title}</p>
          </div>

          <div className="text-muted-primary flex flex-col gap-1 md:items-end">
            <p className="text-[10px] leading-4">
              ©{year} {title}
            </p>
            <p className="text-[10px] leading-4">All rights reserved.</p>
          </div>
        </div>
      </Wrapper>
    </footer>
  );
};
